import { Button, styled } from '@mui/material';

import { ReactComponent as ArrowDownIcon } from 'assets/icons/startPage/arrowDownOutlined.svg';

export const ToggleArrowIcon = styled(ArrowDownIcon)<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.2s ease;
`;

export const ToggleBtn = styled(Button)`
  width: fit-content;
  min-width: unset;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.p080};
  box-shadow: none;
  text-transform: none;
  height: 44px;
  padding: 4px 10px;
  gap: 6px;
  justify-content: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    box-shadow: none;
  }
`;

export const Triangle = styled('span')`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 4px 0 4px;
  border-color: #000000 transparent transparent transparent;
`;

export const OptionBtn = styled(ToggleBtn)`
  width: fit-content;
`;
